import { XYChart } from '@amcharts/amcharts5/xy';
import React from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import { setSeries } from 'features/Status/components/StatusHistory/StatusHistoryChart/utils/setSeries';
import { StatusData } from 'features/Status/types/statusData';
import { am5Root, am5XYChart, dateAxis, valueAxis, yAxisRenderer } from 'utils/charts/charts';
import { setAxisRenderer } from 'utils/charts/setAxisRenderer';
import { setCursor } from 'utils/charts/setCursor';
import { setCursorSelectBehaviour } from 'utils/charts/setCursorSelectBehaviour';
import {
  cursorSettingsWithEnabledSelect,
  getXYChartSettings,
  xAxisRendererSettings,
  yAxisRendererSettings,
  xAxisStatusSettings,
} from 'utils/charts/settings';

export const initialiseChart = (
  chartId: string,
  minDateTimeRange: string,
  maxDateTimeRange: string,
  chartData: StatusData[],
  lineColor: string,
  dateTimeRange?: Dates,
  setDateTimeRange?: React.Dispatch<React.SetStateAction<Dates>>,
  amchartsLicenseKey?: string
) => {
  const root = am5Root(chartId, amchartsLicenseKey);
  const chart: XYChart = root.container.children.push(am5XYChart(root, getXYChartSettings()));

  const yAxis = chart.yAxes.push(
    valueAxis(root, {
      min: 0,
      max: 4,
      renderer: yAxisRenderer(root, {}),
    })
  );
  yAxis.data.setAll(chartData);

  const xAxis = chart.xAxes.push(
    dateAxis(root, xAxisStatusSettings(root, minDateTimeRange, maxDateTimeRange))
  );

  yAxis.get('renderer').labels.template.set('visible', false);
  xAxis.get('renderer').labels.template.set('visible', false);
  xAxis.get('renderer').axis.set('visible', false);

  chart.set('wheelX', 'none');
  chart.set('wheelY', 'none');
  chart.set('panX', false);
  chart.set('panY', false);

  setAxisRenderer(yAxis, yAxisRendererSettings);
  setAxisRenderer(xAxis, xAxisRendererSettings);

  const cursor = setCursor(root, chart, cursorSettingsWithEnabledSelect(true));
  setCursorSelectBehaviour(dateTimeRange, cursor, xAxis, setDateTimeRange);

  setSeries(root, chart, yAxis, xAxis, chartData, lineColor);

  chart.appear(1000, 100);
  return root;
};
